// extracted by mini-css-extract-plugin
module.exports = {"contact":"contact-module--contact--1EO9M","light":"contact-module--light--1QuzF","infoMessage":"contact-module--info-message--QDBvu"};